/**
 * @fileoverview This file declares the global color variables used in the application
 * Changing these values will change the color scheme of the application
 * Also, changing values in tailwind.config.js will change the color scheme of the application
 */

export const PRIMARY_COLOR = "#ea5919";
export const SECONDARY_GRAPH_COLOR = "#656864";
export const colorMap = {
  0: `${SECONDARY_GRAPH_COLOR}`, // Secondary color stays at index 0
  1: "#6f95ef", // Was at index 2, shifted to 1
  2: "#b5625b", // Was at index 3, shifted to 2
  3: "#db8954", // Was at index 4, shifted to 3
  4: "#B39B00", // Was at index 5, shifted to 4
  5: "#57b3cc", // Was at index 6, shifted to 5
  6: "#c87fbd", // Was at index 7, shifted to 6
  7: "#ff9a76", // Was at index 8, shifted to 7
  8: "#98d98e", // Was at index 9, shifted to 8
  9: "#c6538c", // Was at index 10, shifted to 9
  10: "#5da6a7", // Was at index 11, shifted to 10
  11: "#a3e5c0", // Was at index 12, shifted to 11
  12: "#755d9b", // Was at index 13, shifted to 12
  13: "#f49580", // Was at index 14, shifted to 13
  14: "#ebc155", // Was at index 15, shifted to 14
  15: "#6382bf", // Was at index 16, shifted to 15
  16: "#f37d6a", // Was at index 17, shifted to 16
  17: "#a9d66f", // Was at index 18, shifted to 17
  18: "#b37cb5", // Was at index 19, shifted to 18
  19: "#6f8bbd", // Was at index 20, shifted to 19
  20: "#f2a541", // Was at index 21, shifted to 20
  21: "#70964b", // Was at index 22, shifted to 21
  22: "#e06179", // Was at index 23, shifted to 22
  23: "#ffbe67", // Was at index 24, shifted to 23
  24: "#c5d583", // Was at index 25, shifted to 24
  25: "#4db6ac", // Was at index 26, shifted to 25
  26: "#d65db1", // Was at index 27, shifted to 26
  27: "#ff7043", // Was at index 28, shifted to 27
  28: "#64b5f6", // Was at index 29, shifted to 28
  29: "#9ccc65", // Was at index 30, shifted to 29
  30: "#ba68c8", // Was at index 31, shifted to 30
  31: "#4fc3f7", // Was at index 32, shifted to 31
  32: "#ffa726", // Was at index 33, shifted to 32
  33: "#7986cb", // Was at index 34, shifted to 33
  34: "#aed581", // Was at index 35, shifted to 34
  35: "#ff8a65", // Was at index 36, shifted to 35
  36: "#4dd0e1", // Was at index 37, shifted to 36
  37: "#a1887f", // Was at index 38, shifted to 37
  38: "#9575cd", // Was at index 39, shifted to 38
  39: "#f06292", // Was at index 40, shifted to 39
  40: "#7cb342", // Was at index 41, shifted to 40
  41: "#ffb74d", // Was at index 42, shifted to 41
  42: "#5c6bc0", // Was at index 43, shifted to 42
  43: "#8d6e63", // Was at index 44, shifted to 43
  44: "#ff7e79", // Was at index 45, shifted to 44
  45: "#78909c", // Was at index 46, shifted to 45
  46: "#9fa8da", // Was at index 47, shifted to 46
  47: "#80deea", // Was at index 48, shifted to 47
  48: "#bcaaa4", // Was at index 49, shifted to 48
  49: "#ce93d8", // Was at index 50, shifted to 49
};
